import { render, staticRenderFns } from "./efresult.vue?vue&type=template&id=a55d7f36&lang=pug&"
import script from "./efresult.vue?vue&type=script&lang=js&"
export * from "./efresult.vue?vue&type=script&lang=js&"
import style0 from "./efresult.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports